import { Clock3, Lightbulb, LockKeyhole, Radio } from "lucide-react";

export function BuildingStage() {
  return (
    <div className="building-stage" aria-label="Demostración: dos teléfonos reciben pistas privadas, comparten una escena y enfrentan una cuenta regresiva con consecuencia">
      <div className="building-status">
        <span><Radio aria-hidden="true" /> Sala 8KM4QZP</span>
        <span>2 de 2 conectados</span>
      </div>
      <div className="facade-grid">
        <div className="facade-window window-private-a">
          <div className="window-topline"><LockKeyhole aria-hidden="true" /><span>Sólo Ana</span></div>
          <p>La copa marca <strong>22:41</strong>.</p>
        </div>
        <div className="facade-window window-shared">
          <div className="sync-core" aria-hidden="true"><span /><span /></div>
          <strong>Las pistas coinciden</strong>
          <p>La sala avanza cuando ambas ventanas están listas.</p>
        </div>
        <div className="facade-window window-private-b">
          <div className="window-topline"><LockKeyhole aria-hidden="true" /><span>Sólo Leo</span></div>
          <p>El registro dice <strong>22:41</strong>.</p>
        </div>
        <div className="facade-window window-timer">
          <div className="window-topline"><Clock3 aria-hidden="true" /><span>Cuenta regresiva</span></div>
          <strong>00:18</strong>
          <p>Si el tiempo se agota, el desenlace se endurece.</p>
        </div>
        <div className="facade-window window-hint">
          <div className="window-topline"><Lightbulb aria-hidden="true" /><span>Pista</span></div>
          <p>Disponible tras 2 intentos · cuesta <strong>25 pts</strong>.</p>
        </div>
        <div className="facade-window window-progress"><span>Próxima escena</span><strong>03</strong></div>
      </div>
      <div className="building-caption">
        <span>Información distinta</span>
        <i aria-hidden="true" />
        <span>Un solo estado</span>
      </div>
    </div>
  );
}
